var map = {
	"./boxbg.jpg": 6709,
	"./caller.jpg": 5706,
	"./coming-soon-bg.jpg": 5067,
	"./img-cropper.jpg": 335,
	"./maintenance-bg.jpg": 4842,
	"./receiver-img.jpg": 9409,
	"./sidebar-bg.jpg": 509,
	"./wallpaper.jpg": 6681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5307;